import React from 'react'

export const Home= () => {

    const organizationSchema = `
        <script type="application/ld+json">
        {
        "@context": "https://schema.org",
        "@type": "MedicalOrganization",
        "name": "Cutis",
        "alternateName": "Cutis Hospital Bangalore",
        "url": "https://www.cutis.org.in/",
        "logo": "https://www.cutis.org.in/assets/img/cutis-logo-with-tm-600-new.png",
        "sameAs": [
            "https://www.facebook.com/CutisHospitals/",
            "https://www.instagram.com/cutishospitalbengaluru/",
            "https://www.youtube.com/c/CutisHospital",
            "https://www.linkedin.com/company/cutis-hospital-skin-hair-nail"
        ]
        }
        </script>
    
    `;

    const websiteSchema = `
        <script type="application/ld+json">
        {
        "@context": "https://schema.org/",
        "@type": "WebSite",
        "name": "Cutis",
        "url": "https://www.cutis.org.in/",
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.cutis.org.in/?s={search_term_string}",
            "query-input": "required name=search_term_string"
        }
        }
        </script>
    
    `;

    const localBusinessSchema = `
        <script type="application/ld+json">
        {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Cutis",
        "image": "https://www.cutis.org.in/assets/img/cutis-logo-with-tm-600-new.png",
        "@id": "",
        "url": "https://www.cutis.org.in/",
        "telephone": "080 2340 1200",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "5/1, 4th Main, MRCR Layout, Magadi Main Rd, Govindaraja Nagar Ward, MC Layout, Vijayanagar",
            "addressLocality": "Bengaluru",
            "postalCode": "560040",
            "addressCountry": "IN"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": 12.9768507,
            "longitude": 77.54495159999999
        },
        "openingHoursSpecification": [{
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday"
            ],
            "opens": "09:00",
            "closes": "20:00"
        },{
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Friday",
            "opens": "11:00",
            "closes": "20:00"
        },{
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": "Saturday",
            "opens": "09:00",
            "closes": "17:00"
        }],
        "sameAs": [
            "https://www.facebook.com/CutisHospitals/",
            "https://www.instagram.com/cutishospitalbengaluru/",
            "https://www.youtube.com/c/CutisHospital",
            "https://www.linkedin.com/company/cutis-hospital-skin-hair-nail"
        ] 
        }
        </script>
    
    `;

    return (
        <div>
            <iframe srcDoc={organizationSchema} title="Organization Schema" width="0" height="0" />
            <iframe srcDoc={websiteSchema} title="Website Schema" width="0" height="0" />
            <iframe srcDoc={localBusinessSchema} title="Local Business Schema" width="0" height="0" />
        
        </div>

    );
};
export default Home;